import { useLocation } from 'react-router-dom';

const tabActiveMap: Record<string, string> = { 1: '/datasets', 2: '/solutions', 3: '/blueprints' };

/** Returns the nav URL that should be highlighted when on /search-results?tab=X, or null otherwise. */
const useSearchTabActiveUrl = (): string | null => {
    const location = useLocation();
    if (!location.pathname.includes('/search-results')) return null;
    const tab = new URLSearchParams(location.search).get('tab');
    return (tab && tabActiveMap[tab]) || null;
};

export default useSearchTabActiveUrl;
